import { DataMultiSelect, DataMultiSelectInheritedProps } from 'components/selects/DataSelect';
import useHrTermTypeOptions from 'components/selects/hr/use-hr-term-type-options';

interface HrTermTypeMultiSelectProps extends DataMultiSelectInheritedProps {
  includeArchived?: boolean;
}

/** Multi-select for authoritative HR term types accessible to the actor. */
export default function HrTermTypeMultiSelect({ includeArchived = true, ...props }: HrTermTypeMultiSelectProps) {
  const fetchTermTypes = useHrTermTypeOptions(includeArchived);

  return <DataMultiSelect action={fetchTermTypes} valueProp="value" labelProp="label" {...props} />;
}
